import React from "reactn";
import "./RequestInfo.css";
import axios from "axios";
import { withRouter } from "react-router-dom";
import BaseModal from "./baseModal/BaseModal";
import { TITLE } from "./baseModal/FieldTypes";
import { BLUE_BUTTON, WHITE } from "./baseModal/colours";

class CancelConfirmationModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  cancelInvoice = async e => {
    e.preventDefault();
    const ep = `${process.env.REACT_APP_API}/partners/orders/update`;
    console.log("ep:", ep);
    console.log("this.props.id:", this.props.id);

    try {
      const res = await axios.post(ep, {
        id: this.props.id,
        status: "Cancelled"
      });

      console.log("Server Response:", res.data);

      if (res.data.success) {
        this.props.confirmCancel();
        this.props.onClose();
      } else {
        alert(`Backend Error: ${res.data.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Request Failed:", err);

      if (err.response) {
        console.log("Error Data:", err.response.data);
        console.log("Error Status:", err.response.status);
      }
    }
  };

  getBaseModalFields() {
    const descriptionText = {
      type: TITLE,
      data: {
        name: "Are you sure you want to cancel issuing this invoice? Cancelling cannot be undone - a new invoice would have to be created."
      }
    };

    const fields = [];

    fields.push(descriptionText);

    return fields;
  }

  getBaseModalButtons = () => {
    const confirmCancel = {
      name: "Cancel",
      buttonColour: BLUE_BUTTON,
      textColour: WHITE,
      handleClick: e => this.cancelInvoice(e)
    };

    const buttonFields = [];

    buttonFields.push(confirmCancel);

    return buttonFields;
  };

  getBaseModalProps = () => {
    return {
      title: "Cancel Invoice",
      fields: this.getBaseModalFields(),
      buttons: this.getBaseModalButtons(),
      height: "65vh",
      midSectionHeight: "49vh",
      handleClose: this.props.onClose
    };
  };

  render() {
    return <BaseModal {...this.getBaseModalProps()} />;
  }
}

export default withRouter(CancelConfirmationModal);
